import { render, staticRenderFns } from "./ViewerFrame.vue?vue&type=template&id=2974bc9a&scoped=true&"
import script from "./ViewerFrame.vue?vue&type=script&lang=ts&"
export * from "./ViewerFrame.vue?vue&type=script&lang=ts&"
import style0 from "./ViewerFrame.vue?vue&type=style&index=0&id=2974bc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974bc9a",
  null
  
)

export default component.exports